import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SubmitCashbackSuccess } from '@features/cashback/store/actions/cashback.actions';
import { LoadPointsSummary } from '@features/points-summary/store/actions/points-summary.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class CheckoutEffects {
  constructor(private actions$: Actions, private router: Router) {}

  submitCashRedemptionSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SubmitCashbackSuccess),
      switchMap(({ orderId }) => {
        this.router.navigate([`/redeem_cash/success/${orderId ?? ''}`]);

        return [new LoadPointsSummary()];
      }),
    ),
  );
}
